import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicPerformanceEvaluation = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Performance Evaluation of Parallel Processors: Amdahl’s Law, Speed-up, and Efficiency"
      videos={[
        "https://www.youtube.com/embed/B1zZaTfS_Vk",
        "https://www.youtube.com/embed/E_2zMAxznys"
      ]}
      takeaways={[
        { text: "Practice as many types of questions as possible from this topic." },
        { text: "Understand how to compute speed-up and efficiency using Amdahl’s Law." },
        { text: "Be prepared to analyze the feasibility of a given speed-up value." }
      ]}
      questions={[]} // Added empty array
      exampleVideos={[]} // No specific example videos provided
    />
);
}

export default ModuleSubtopicPerformanceEvaluation;
